import http from '@/utils/http';
import { simulateFakeProgress } from '@home/utils/simulateProgress';

// 获取looker 报表
export const getLooker: (data: any) => Promise<any> = (data) =>
  http({
    url: '/api/v1/permission/looker/signed_url',
    method: 'post',
    data,
  });

// 获取looker 更新token
export const generateTokens: (data: any) => Promise<any> = (data) =>
  http({
    url: '/api/v1/dashboard/looker/generate_token',
    method: 'post',
    data,
  });

// 获取preset信息
export const getPresetInfo: (data: string, url: string) => Promise<any> = (data, url) =>
  http({
    url: `${url}${data}`,
    method: 'get',
    data,
  });

// 获取pdf cos
export const getPdfCos: (data: any, url: string) => Promise<any> = (data, url) =>
  http({
    url,
    method: 'post',
    data,
  });

// 获取tableau ticker
export const getTicket: (data: any, url: string) => Promise<any> = (data, url) =>
  http({
    url,
    method: 'post',
    data,
  });

export const recognizeReport = (params: FormData) => {
  return http({
    url: '/api/v1/intelligence_pc/ai/report/analysis',
    method: 'post',
    data: params,
    rawData: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }) as any;
};

const formatRecognizeReportResult = (data: any) => {
  const langMap = data?.['报告语言'] || {};
  const titleMap = data?.['报告标题'] || {};
  const introductionMap = data?.['报告摘要'] || {};
  const tagsMap = data?.['报告标签'] || {};
  const cover = data?.['报告封面'] || '';

  return {
    report_language: langMap?.zh || '',
    report_language_en: langMap?.en || '',
    title: titleMap?.zh || '',
    title_en: titleMap?.en || '',
    introduction: introductionMap?.zh || '',
    introduction_en: introductionMap?.en || '',
    tag: tagsMap?.zh?.filter(Boolean) || [],
    tag_en: tagsMap?.en?.filter(Boolean) || [],
    cover: cover || '',
  };
};

export const recognizeReportService = async (file: File, options: any) => {
  // 1. 开启模拟进度
  const { stop: stopSimulateFakeProgress } = simulateFakeProgress({ onProgress: options?.onProgress });

  // 2. 真实请求（并行执行）
  const fd = new FormData();
  fd.append('file', file);

  let res: any;
  let resData: any;

  try {
    res = await recognizeReport(fd);
    resData = res?.data;
  } catch (error) {
    throw error;
  } finally {
    // 3. 停止模拟进度，自动冲刺到100%
    stopSimulateFakeProgress();
  }

  // 4. 返回真实识别结果
  return {
    ...res,
    data: {
      ...resData,
      data: formatRecognizeReportResult(resData?.data),
    },
  };
};
